var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3754_22)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6324 4.91077C11.7032 4.02449 10.463 3.54167 9.17992 3.56151C6.83196 3.56151 4.83785 5.14555 4.12684 7.27855C3.74984 8.39631 3.74984 9.60672 4.12683 10.7245H4.13013C4.84445 12.8542 6.83526 14.4382 9.18323 14.4382C10.3952 14.4382 11.4358 14.1282 12.2422 13.5807V13.5784C13.1913 12.9501 13.8395 11.9613 14.0412 10.8436H9.17993V7.37782H17.669C17.7748 7.9797 17.8244 8.5948 17.8244 9.20659C17.8244 11.944 16.8462 14.2583 15.144 15.8258L15.1458 15.8272C13.6543 17.2029 11.6073 17.9999 9.17992 17.9999C5.77702 17.9999 2.66513 16.0818 1.1373 13.0427C-0.139194 10.4996 -0.139191 7.50347 1.13731 4.9604C2.66514 1.91796 5.77702 -0.000125922 9.17992 -0.000125922C11.4155 -0.0265819 13.5749 0.813396 15.202 2.34123L12.6324 4.91077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3754_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.862dfbb2866ed1e401a8c3ad964bb9aa.svg";
export { ForwardRef as ReactComponent };